/* eslint-disable @typescript-eslint/ban-types */
import "./index.less";
import AITip from "./AITip";
import AIInput from "./AIInput";
import AIChatContent from "./AIChatContent";
import { useEffect, useRef } from "react";
import { RuningInLink } from "@/constants";
import summaryCommonStore from "@/store/summaryCommon.store";
import ChatStore from "@/store/chat.store";
import { MessageSource } from "@/services/api_question";
import { debounce } from "@common/utils";
import CloseIcon from "@/assets/common/ic_close_small.svg?react";
import AIQAStore from "@/store/AIQA.store";
import fridayReporter from "@/utils/friday";
import { IS_PRIVATE } from "@/config";

export interface IProps {
  onlyContent?: boolean;
}

const AIQA = ({ onlyContent = false }: IProps) => {
  const streamId = summaryCommonStore((state) => state.streamId);
  const inputValue = ChatStore((state) => state.inputValue);
  const messageList = ChatStore((state) => state.messageList);
  const { setInputValue } = ChatStore.getState();
  const toggleAIQAMode = AIQAStore((state) => state.toggleAIQAMode);

  const debounceFn = useRef<Function>(
    debounce(() => {
      console.log('streamId', streamId);
      if (streamId) {
        ChatStore.getState().getMessageList().then(() => {
          setTimeout(() => {
            scrollToBottom();
          }, 30);
        });
        ChatStore.getState().getQuestions();
      }
    }, 300)
  );

  const contentRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    contentRef.current?.scrollTo({
      top: contentRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleInputConfirm = async (value: string, source: MessageSource) => {
    if (value.trim() === "") return;
    switch (source) {
      case MessageSource.MANUAL:
        fridayReporter.pushData({
          eventCode: "SummaryPage_AI_SentQuestion",
          payload: {
            problem_source: "文本框输入",
          },
        });
        break;
      case MessageSource.QUESTION_LIB:
        fridayReporter.pushData({
          eventCode: "SummaryPage_AI_SentQuestion",
          payload: {
            problem_source: "猜你想问",
          },
        });
        break;
      case MessageSource.ASSOCIATION:
        fridayReporter.pushData({
          eventCode: "SummaryPage_AI_ContinueQuestion",
        });
        break;
      default:
        break;
    }
    setTimeout(() => {
      scrollToBottom();
    }, 30);
    try {
      await ChatStore.getState().sendQuestion({
        message: value,
        messageSource: source,
      });
      setInputValue("");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // 私有化环境下不调用接口
    if (IS_PRIVATE) {
      return;
    }
    ChatStore.getState().setStreamName(`live/${streamId}`);
    debounceFn.current();
    return () => {
      ChatStore.getState().resetStore();
    };
  }, [streamId]);

  const content = (
    <div className="content">
      <div className="scroll-content" ref={contentRef}>
        {/* 三个组件都传了，后面直接放store里吧 */}
        <AITip onChange={setInputValue} onConfirm={handleInputConfirm} />
        <AIChatContent content={messageList} onChange={setInputValue} onConfirm={handleInputConfirm} />
      </div>
      <AIInput value={inputValue} onChange={setInputValue} onConfirm={handleInputConfirm} />
    </div>
  )

  return onlyContent ? content : (
    <div className={`AIQA ${RuningInLink ? "app" : "web"}`}>
      <div className="empty-placeholder"></div>
      <div className="main-content">
        <div className="header">
          <div className="title">AI对话</div>
          <CloseIcon className="no_drag position-absolute top-4.5 right-3.5 size-6 cursor-pointer" onClick={() => toggleAIQAMode(false)} />
        </div>
        {content}
      </div>
    </div>
  );
};

export default AIQA;
